/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CarrierPermission = {
    UsersRead: 'USERS_READ',
    UsersFull: 'USERS_FULL',
    LoadRead: 'LOAD_READ',
    LoadFull: 'LOAD_FULL',
    ProfileRead: 'PROFILE_READ',
    ProfileFull: 'PROFILE_FULL',
    LoadDirectRead: 'LOAD_DIRECT_READ',
    LoadDirectFull: 'LOAD_DIRECT_FULL',
    FleetBoardRead: 'FLEET_BOARD_READ',
    FleetBoardFull: 'FLEET_BOARD_FULL',
    DirectCustomerRead: 'DIRECT_CUSTOMER_READ',
    DirectCustomerFull: 'DIRECT_CUSTOMER_FULL',
    MapRead: 'MAP_READ'
} as const;
export type CarrierPermission = typeof CarrierPermission[keyof typeof CarrierPermission];

